/* ============================================================
   GRAY / MOVIE — サムネイルのクリックで埋め込み再生をモーダル表示する
   theme: assets/gray-movie.js

   ・カードは <a href="動画URL"> のままなので、JSが動かない環境や
     cmd/ctrl クリックでは従来どおり動画ページへ遷移する
   ・iframeは開いた時に作り、閉じた時に外す。外すことで再生が止まる
   ・Tailwindは assets/*.js を走査しないため、ここでclassを付与しない。
     iframeの見た目はliquid側の [&>iframe]:* で当てている
   ============================================================ */
(function () {
  'use strict';

  /* sectionごとにscriptが出るため、多重初期化を防ぐ */
  if (window.__grayMovieInit) return;
  window.__grayMovieInit = true;

  function embedSrc(type, id) {
    if (!id) return '';
    var vid = encodeURIComponent(id);
    if (type === 'youtube') {
      return 'https://www.youtube-nocookie.com/embed/' + vid + '?autoplay=1&rel=0&playsinline=1';
    }
    if (type === 'vimeo') {
      return 'https://player.vimeo.com/video/' + vid + '?autoplay=1';
    }
    return '';
  }

  function teardown(dialog) {
    var frame = dialog.querySelector('[data-gray-movie-frame]');
    /* iframeを外すことで再生を止める */
    if (frame) frame.replaceChildren();
    document.body.style.overflow = '';
  }

  /* closeイベントに頼らず、閉じる経路すべてでここを通す。
     環境によってはdialogのcloseイベントが発火せず、iframeが残って
     音声が鳴り続けることがあるため。 */
  function closeMovieDialog(dialog) {
    if (!dialog) return;
    teardown(dialog);
    if (dialog.open) dialog.close();
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var trigger = event.target.closest('[data-gray-movie-trigger]');
    if (trigger) {
      /* 新規タブで開く操作は邪魔しない */
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

      var root = trigger.closest('[data-gray-movie-root]');
      var dialog = root && root.querySelector('[data-gray-movie-modal]');
      var frame = dialog && dialog.querySelector('[data-gray-movie-frame]');
      var src = embedSrc(trigger.getAttribute('data-video-type'), trigger.getAttribute('data-video-id'));

      /* 条件が揃わない時は既定のリンク遷移に任せる */
      if (!dialog || !frame || !src || typeof dialog.showModal !== 'function') return;

      event.preventDefault();

      var iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.title = trigger.getAttribute('data-video-title') || '';
      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
      );
      iframe.setAttribute('allowfullscreen', '');
      frame.replaceChildren(iframe);

      document.body.style.overflow = 'hidden';
      dialog.showModal();
      return;
    }

    var closeBtn = event.target.closest('[data-gray-movie-close]');
    if (closeBtn) {
      closeMovieDialog(closeBtn.closest('[data-gray-movie-modal]'));
      return;
    }

    /* 背景（dialog自身）のクリックで閉じる */
    var modal = event.target.closest('[data-gray-movie-modal]');
    if (modal && event.target === modal) closeMovieDialog(modal);
  });

  /* Escはブラウザ既定の閉じ方に任せず自前で処理する */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('[data-gray-movie-modal][open]');
    if (!open) return;
    event.preventDefault();
    closeMovieDialog(open);
  });

  /* 上記以外の経路で閉じられた場合の保険。発火しない環境もあるため単独では頼らない */
  document.addEventListener(
    'close',
    function (event) {
      var el = event.target;
      if (el && el.matches && el.matches('[data-gray-movie-modal]')) teardown(el);
    },
    true
  );
})();
